// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toolbar":"toolbar-3zCQ0wHh","partTitle":"partTitle-wXOEOn5Y","partMore":"partMore-2S62NZL2","videoList":"videoList-_ucPznlA"};